import { Box, Button, Typography } from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import api from '../../api/client';
import React from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { departmentsState } from '../../pages/admin/atoms'
import { loadingState } from '../../recoil/atoms'
import { toast } from '../../api/toast'

const DeleteDepartment = props => {
    const [departments, setDepartments] = useRecoilState(departmentsState)
    const currentDepartment = departments.filter(d => d.id === props.id)[0]
    const setLoading = useSetRecoilState(loadingState)

    const deleteHandler = () => {
        setLoading(true)
        api.delete('users/departments/' + props.id)
            .then(response => {
                if (response.status === 200) {
                    setDepartments(departments.filter(d => d.id !== props.id))
                    props.setOpenDeleteDepartment(-1)
                } else {
                    toast('خطا در حذف سازمان')
                }
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
                toast('خطا در حذف سازمان')
            })
    }

    if (!currentDepartment) return null

    return (
        <>
            <Box display="flex" alignItems="flex-start" gap={1.5} style={{ background: '#fff3f3', border: '1px solid #ffcdd2', borderRadius: 10, padding: 14 }}>
                <WarningIcon style={{ color: '#c62828', fontSize: 30, flexShrink: 0 }} />
                <Box>
                    <Typography style={{ fontWeight: 800, color: '#c62828' }}>
                        حذف «{currentDepartment.name}»
                    </Typography>
                    <Typography variant="body2" style={{ marginTop: 6, lineHeight: 2, color: '#555' }}>
                        حساب کاربری این سازمان از سامانه حذف می‌شود و دسترسی آن قطع خواهد شد. این عملیات برگشت‌پذیر نیست و داده‌های بارگذاریشده از دسترس خارج می‌شوند.
                    </Typography>
                </Box>
            </Box>
            <Box mt={2} display="flex" gap={1}>
                <Button
                    variant="contained"
                    style={{ backgroundColor: '#c62828', color: '#fff', fontWeight: 'bold' }}
                    onClick={() => deleteHandler()}
                >
                    بله، حذف شود
                </Button>
                <Button variant="outlined" color="default" onClick={() => props.setOpenDeleteDepartment(-1)}>
                    انصراف
                </Button>
            </Box>
        </>
    )
}

export default DeleteDepartment
